import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import {
  getAgencyDataFormInstance,
  getConfigDataFormInstance,
} from '@modules/business-accounts/forms/utils/config-step/builders/config-natural-person-builder.class';
import { ParametersService } from '@modules/business-accounts/services/parameters/parameters.service';
import { NullableObservable } from '@modules/business-accounts/utils/types/observable.type';
import { AssetLink } from '@utils/helpers/asset-cpm-link';
import { IStep } from '../../utils/interfaces/step.interface';
import { TraceService } from '@modules/business-accounts/services/trace/trace.service';
import { VisitEvent } from '@modules/business-accounts/utils/classes/visit-event.class';
import { TraceEventName } from '@modules/business-accounts/utils/enums/trace-events.enum';

export interface Province {
  storeCode: string;
  deparment: string;
  province: string;
}

@Component({
  selector: 'ba-legal-person-configuration-step',
  templateUrl: './legal-person-configuration-step.component.html',
  styleUrls: ['./legal-person-configuration-step.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class LegalPersonConfigurationStepComponent extends AssetLink() implements OnInit, IStep<void> {
  @Output() stepDone = new EventEmitter<void>();

  showPlanDetails: boolean = false;
  provinces$!: NullableObservable<ReturnType<ParametersService['getProvinces']>>;
  departmentList: { value: string; label: string }[] = [];

  deparments = [
    { deparment: 'Ancash' },
    { deparment: 'Arequipa' },
    { deparment: 'Ayacucho' },
    { deparment: 'Apurimac' },
    { deparment: 'Cajamarca' },
    { deparment: 'Cerro de Pasco' },
    { deparment: 'Cusco' },
    { deparment: 'Ica' },
    { deparment: 'Junín' },
    { deparment: 'La Libertad' },
    { deparment: 'Lambayeque' },
    { deparment: 'Lima' },
    { deparment: 'Loreto' },
    { deparment: 'Moquegua' },
    { deparment: 'Piura' },
    { deparment: 'Puno' },
    { deparment: 'San Martín' },
    { deparment: 'Tacna' },
    { deparment: 'Ucayali' },
    { deparment: 'Callao' },
    { deparment: 'Tumbes' },
    { deparment: 'Madre de Dios' },
    { deparment: 'Huánuco' },
  ];

  provinces: Province[] = [];
  allProvinces: Province[] = [
    { storeCode: '620', deparment: 'Ancash', province: 'Santa' },
    { storeCode: '622', deparment: 'Ancash', province: 'Huaraz' },
    { storeCode: '300', deparment: 'Arequipa', province: 'Arequipa' },
    { storeCode: '440', deparment: 'Ayacucho', province: 'HUAMANGA' },
    { storeCode: '702', deparment: 'Cajamarca', province: 'Cajamarca' },
    { storeCode: '590', deparment: 'Cerro de Pasco', province: 'Cerro de Pasco' },
    { storeCode: '420', deparment: 'Cusco', province: 'Cusco' },
    { storeCode: '400', deparment: 'Ica', province: 'Ica' },
    { storeCode: '402', deparment: 'Ica', province: 'Chincha' },
    { storeCode: '404', deparment: 'Ica', province: 'Pisco' },
    { storeCode: '500', deparment: 'Junín', province: 'Huancayo' },
    { storeCode: '600', deparment: 'La Libertad', province: 'Trujillo' },
    { storeCode: '700', deparment: 'Lambayeque', province: 'Chiclayo' },
    { storeCode: '522', deparment: 'Lima', province: 'Huaral' },
    { storeCode: '523', deparment: 'Lima', province: 'Barranca' },
    { storeCode: '401', deparment: 'Lima', province: 'Cañete' },
    { storeCode: '740', deparment: 'Loreto', province: 'MAYNAS' },
    { storeCode: '341', deparment: 'Moquegua', province: 'Ilo' },
    { storeCode: '720', deparment: 'Piura', province: 'Piura' },
    { storeCode: '723', deparment: 'Piura', province: 'Talara' },
    { storeCode: '320', deparment: 'Puno', province: 'Puno' },
    { storeCode: '322', deparment: 'Puno', province: 'San Román' },
    { storeCode: '750', deparment: 'San Martín', province: 'San Martín' },
    { storeCode: '340', deparment: 'Tacna', province: 'Tacna' },
    { storeCode: '760', deparment: 'Ucayali', province: 'Coronel Portillo' },
    { storeCode: '100', deparment: 'Lima', province: 'Lima' },
    { storeCode: '145', deparment: 'Callao', province: 'Callao' },
    { storeCode: '732', deparment: 'Piura', province: 'Sullana' },
    { storeCode: '731', deparment: 'Tumbes', province: 'Tumbes' },
    { storeCode: '335', deparment: 'Madre de Dios', province: 'Tambopata' },
    { storeCode: '527', deparment: 'Lima', province: 'Huaura' },
    { storeCode: '361', deparment: 'Moquegua', province: 'Mariscal Nieto' },
    { storeCode: '758', deparment: 'San Martín', province: 'Moyobamba' },
    { storeCode: '736', deparment: 'Piura', province: 'Paita' },
    { storeCode: '588', deparment: 'Apurimac', province: 'Abancay' },
    { storeCode: '550', deparment: 'Arequipa', province: 'Camaná' },
    { storeCode: '589', deparment: 'Apurimac', province: 'Cotabambas' },
    { storeCode: '546', deparment: 'Junín', province: 'Chanchamayo' },
    { storeCode: '367', deparment: 'Ica', province: 'Nazca' },
    { storeCode: '562', deparment: 'Huánuco', province: 'Huánuco' },
    { storeCode: '772', deparment: 'La Libertad', province: 'Pataz' },
    { storeCode: '765', deparment: 'Cajamarca', province: 'Jaen' },
    { storeCode: '769', deparment: 'Ucayali', province: 'Pucallpa' },
  ];

  @Input() accountsNumber: number = 0;
  @Input() showErrorDisclaimer = false;
  @Input() showWarnDisclaimer = false;
  @Input() isButtonDisabled = false;
  @Input() isLoading = false;
  constructor(
    public readonly controlContainer: ControlContainer,
    public readonly paramsService: ParametersService,
    private readonly traceService: TraceService
  ) {
    super();
  }

  ngOnInit(): void {
    this.paramsService.params$('departments').subscribe((deparments) => {
      this.departmentList = deparments;
    }); //Only to get the list with code.
    this.listenToDepartmentChange();
    this.listenToProvinceChange();
  }

  get form() {
    return (this.controlContainer as FormGroupDirective).form;
  }

  get configDataForm() {
    return getConfigDataFormInstance({ from: this.form });
  }

  get agencyDataForm() {
    return getAgencyDataFormInstance({ from: this.form });
  }

  onPlanDetailsClick() {
    this.showPlanDetails = !this.showPlanDetails;
  }

  listenToDepartmentChange() {
    this.agencyDataForm.get('department')!.valueChanges.subscribe((res) => {
      const deparment = this.departmentList.find((dep) => dep.label === res);
      if (deparment) this.agencyDataForm.get('departmentCode')?.setValue(deparment.value);
      this.provinces = this.allProvinces.filter((prov) => prov.deparment === res);
      this.agencyDataForm.get('province')?.setValue(null, { emitEvent: false });
    });
  }

  listenToProvinceChange() {
    this.agencyDataForm.get('province')!.valueChanges.subscribe((res) => {
      const province = this.allProvinces.find((prov) => prov.province === res);
      if (province) {
        this.form.get('storeData')?.get('storeCode')?.setValue(province.storeCode);
      }
    });
  }

  done() {
    this.traceService.registerEvent(new VisitEvent(TraceEventName.ACTION_ACCOUNT_DATA));
    this.stepDone.emit();
  }
}
